import { Component, OnInit } from '@angular/core';
import { RequestMoneyService } from '../request-money.service';

@Component({
  selector: 'app-request-step4',
  templateUrl: './request-step4.component.html',
  styleUrls: ['./request-step4.component.scss']
})
export class RequestStep4Component implements OnInit {

  constructor(public requestMoneyervice:RequestMoneyService) { }

  ngOnInit(): void {
    if(!this.requestMoneyervice.step1Data || !this.requestMoneyervice.step2Data){
      this.requestMoneyervice.goTo("step1")
    }
  }



}
